"use client";

import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts";
import type { YearValue } from "@/lib/data/types";

export function Sparkline({ data }: { data: YearValue[] }) {
  if (data.length < 2) {
    return <div className="h-8 w-20" aria-hidden="true" />;
  }

  return (
    <div className="h-8 w-20">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 2, right: 2, left: 2, bottom: 2 }}>
          <YAxis domain={["auto", "auto"]} hide />
          <Line
            type="linear"
            dataKey="value"
            stroke="#26407F"
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
